import React from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";
import PropTypes from "prop-types";

import { Button } from "../button/Button";

import "./ButtonLink.scss";

export const ButtonLink = ({ children, to, className, ...attrs }) => (
  <Button
    as={Link}
    to={to}
    className={classnames("button-link", className)}
    size={"medium"}
    {...attrs}
  >
    {children}
  </Button>
);

ButtonLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  to: PropTypes.string.isRequired,
};
